import Alpine from 'alpinejs'
import dragula from 'dragula'
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons';
library.add(fas);
dom.watch()  // replaces <i> tags with SVGs

window.Alpine = Alpine
Alpine.start()

